import {keys, difference, keyBy, first, filter, map, omit, toNumber} from 'helpers';

export function files(state = {}, action) {
  switch (action.type) {
    case 'ACTIVITIES_UPDATE':
    case 'FILES_UPLOAD':
      if (action.file) {
        let { modelId, modelType } = action.file;
        modelId = toNumber(modelId) ? modelId : action.generateId(modelId);
        let current = filter(state, file => file.modelId == modelId && file.modelType == modelType && /image/.test(file.type));
        if (action.file.remove) {
          return omit(state, map(current, 'id'));
        }
        if (action.file.justUploaded) {
          return {
            ...omit(state, map(current, 'id')),
            [action.generateId('fileId')]: {
              contentPlain: action.file.contentPlain.replace(/^.*?,/, ''),
              contentPrefix: first(/^.*?,/.exec(action.file.contentPlain)),
              id: action.generateId('fileId'),
              modelId,
              modelType,
              serverId: action.generateId('fileId'),
              type: 'image',
              fileType: '',
              toJSON,
            }
          }
        }
      }
      return state;

    case 'SERVER_DATA_RECEIVED':
      const removed = difference(keys(state), action.existingElementIds.files);
      if (action.files.length || removed.length) {
        return omit({
          ...state,
          ...keyBy(action.files, 'id'),
        }, removed);
      }
      return state;

    case 'FILES_REMOVE':
        return omit(state, map(action.files, 'id'));

    case 'TESTING_DELETE_ALL':
      return {};

    default:
      return state;
  }
}

function toJSON() {
  return omit(this, 'contentPlain', 'contentPrefix');
}
